import { Radio, Stack } from '@mui/material';
import { FC, useState } from 'react';

import { FormRadioStyled } from '../../../components/uikit-components/FormCheckbox/FormRadio.styled';
import { RegisterPeriod } from './types';

type CoupledStructureConfirmProps = {
  options: RegisterPeriod[];
  onChange: (periodId: string) => void;
};

export const CoupledStructureConfirm: FC<CoupledStructureConfirmProps> = ({
  options,
  onChange,
}) => {
  const [selectedPeriodId, setSelectedPeriodId] = useState(options[0]?.id);

  const handleChange = (periodId: string) => {
    setSelectedPeriodId(periodId);
    onChange(periodId);
  };

  return (
    <Stack mt={2} gap={2} alignItems="flex-start">
      {options.map((period) => (
        <FormRadioStyled
          key={period.id}
          label={period.structure.name}
          control={
            <Radio
              checked={selectedPeriodId === period.id}
              onChange={() => handleChange(period.id)}
            />
          }
        />
      ))}
    </Stack>
  );
};
